// extracted by mini-css-extract-plugin
module.exports = {"game":"Game_game__7oRz4","mapWrapper":"Game_mapWrapper__BTfOj","map":"Game_map__7bNjd","shadowfilter":"Game_shadowfilter__1PHFE"};